

































import { computed, defineComponent, ref } from '@nuxtjs/composition-api';
import { useCart } from '~/composables';
import cartGetters from '~/modules/checkout/getters/cartGetters';
import Warning from '../../atoms/Warning/Warning.vue';
import JetRadio from '../../molecules/JetRadio/JetRadio.vue';

export default defineComponent({
  name: 'InstallmentsForm',
  components: {
    JetRadio,
    Warning,
  },
  emits: ['status'],
  setup(_props, { emit }) {
    const selectedOption = ref(null);
    const { cart } = useCart();
    const totals = computed(() => cartGetters.getTotals(cart.value));

    const defineInstallment = (option: any) => {
      selectedOption.value = option.number_installments;
      emit('input', option);
    };

    const options = computed(() => {
      const value = totals.value.total;
      const optionsArray = [];

      const maxInstallments = 10;
      const minValue = 33.33;
      const interest = 1.0319;
      const minInterest = 3;

      for (let i = 1; i < maxInstallments + 1; i++) {
        const installment = value / i;
        if (installment > minValue) {
          let totalToPay = value;

          if (i > minInterest) {
            totalToPay = (installment * minInterest) + (installment * interest) * (i - minInterest);
          }

          optionsArray.push({
            value: installment,
            number_installments: i,
            amount: totalToPay,
          });
        } else {
          break;
        }
      }

      if (optionsArray.length === 0) {
        emit('input', {
          value,
          number_installments: 1,
          amount: value,
        });
      }

      return optionsArray;
    });

    return {
      options,
      defineInstallment,
      selectedOption,
    };
  },
});
